import { AreaName } from 'domain/constants';
import { CommentAnchor } from 'library/components/controls/comments/CommentAnchor';
import { useDialogState } from 'library/hooks/useDialogState';
import { OperationType } from 'library/models/enums/OperationType';
import { useAppSelector } from 'library/redux/hooks';
import { createArea } from 'library/utils/helpers/AreaHelper';
import Authorize from 'main/auth/Authorize';
import { ProductCardActionProps } from 'modules/Shared/State/unit/Types';
import { selectProductIndividualCommentsCount } from 'modules/UnitOverview/State/Selectors';

import { ProductIndividualCardCommentsDialog } from './ProductIndividualCommentsDialog';

interface ProductIndividualCommentsProps extends ProductCardActionProps {
	isForeign?: boolean;
}

export const ProductIndividualComments = ({
	disabled,
	id,
	serialNumber,
	...props
}: ProductIndividualCommentsProps) => {
	const { open, handleOpen, handleClose } = useDialogState(false);
	const count = useAppSelector(selectProductIndividualCommentsCount(id));

	return count != null ? (
		<Authorize
			area={createArea(AreaName.UnitComments, OperationType.Read)}
			displayIntermediatePages={false}
			redirectWhenNotAuthorized={false}>
			<CommentAnchor
				count={count}
				dataTestId={`comment-anchor-${serialNumber}`}
				disabled={disabled}
				onClick={handleOpen}
			/>
			{open && (
				<ProductIndividualCardCommentsDialog
					onClose={handleClose}
					open={open}
					id={id}
					serialNumber={serialNumber}
					{...props}
				/>
			)}
		</Authorize>
	) : null;
};
